import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TemostaDataListValidationDto} from 'shared/dtos/temosta-data-list-validation-dto';
import {TesmostaDatalistValidatorValue} from 'shared/EnumsConstants/tesmosta-datalist-validator-value.enum';

@Pipe({
  name: 'dynamicCellStatusTooltip',
  standalone: false,
  pure: false
})
export class DynamicCellStatusTooltipPipe implements PipeTransform {
  constructor(private readonly translateservice: TranslateService) {}

  transform(
    validator: TemostaDataListValidationDto[],
    auswertungAusgeschlossen: any
  ): unknown {
    let count = validator.filter(
      v => v && v.value === TesmostaDatalistValidatorValue.UngueltigerWert
    ).length;
    if (count > 0) {
      return this.translateservice.instant(
        'i18n.analyseDurchführen.datenPruefen.dataSheet.mouseover.error.summaryStatusUngueltige'
      );
    }

    count = validator.filter(
      v => v && v.value === TesmostaDatalistValidatorValue.AuffaelligerWert
    ).length;
    if (count > 0) {
      return this.translateservice.instant(
        'i18n.analyseDurchführen.datenPruefen.dataSheet.mouseover.error.AuffaelligerWert'
      );
    }

    return '';
  }
}
